import React, { useEffect, useState } from "react";
import { Badge, Modal } from "react-bootstrap";
import {
  currencyFormatter,
  toastOption
} from "../../../../../../_metronic/_helpers";
import {
  ORG_CONSOLIDATION_STATUS,
  ORG_CONSOLIDATION_STATUS_DESC,
  toMonthName
} from "../../../../../config/helper";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import { StatusColumnFormatter } from "../organization-report-table/column-formatters";
import ListGroup from "react-bootstrap/ListGroup";
import { ORGANIZATION_REPORT_STATUS } from "../OrganizationReportUIHelpers";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  createOrganizationReport,
  getOrganizationReportById
} from "../../../_redux/organization-report/organizationReportAction";
import { toast } from "react-toastify";
import { generateMemoPPD } from "../../../_redux/consolidation-report/consolidationReportCrud";
import GenerateMemoModal from "../generate-memo-modal/GenerateMemoModal";

const leftSideDetail = [
  {
    label: "Tahun",
    key: "year"
  },
  {
    label: "Bulan",
    key: "month"
  },
  {
    label: "Nama Bank",
    key: "bank_name"
  },
  {
    label: "Rekening Bank",
    key: "bank_account"
  },
  {
    label: "Atas Nama Bank",
    key: "bank_account_behalf"
  }
];

const rightSideDetail = [
  {
    label: "Zakat",
    key: "zakat"
  },
  {
    label: "Infak",
    key: "infaq"
  },
  {
    label: "Sedekah",
    key: "alms"
  },
  {
    label: "Lainnya",
    key: "other"
  }
];

const attachmentList = [
  {
    label: "Bukti Pembayaran",
    key: "file_evidence_of_transfer"
  },
  {
    label: "Form Pencairan",
    key: "file_disbursement_form"
  },
  {
    label: "Rencana Penggunaan Dana",
    key: "file_fund_use_plan"
  },
  {
    label: "Laporan Keuangan Bulan Sebelmunya",
    key: "file_prev_month_financial"
  },
  {
    label: "Laporan Kegiatan",
    key: "file_activity_report"
  }
];

export default function OrganizationReportDetail({
  match: {
    params: { id }
  },
  history
}) {
  const [openModal, setOpenModal] = useState({
    generate: false
  });
  const [loading, setLoading] = useState(false);
  const [consolidationStatus, setConsolidationStatus] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrganizationReportById(id));
  }, [id]);

  const { organizationReportForEdit = {}, actionsLoading } = useSelector(
    state => state.superAdminOrganizationReport,
    shallowEqual
  );

  const {
    uuid,
    organization = {},
    status,
    zakat,
    infaq,
    alms,
    other,
    organization_uuid
  } = organizationReportForEdit;
  const subTotal = +zakat + +infaq + +alms + +other;

  useEffect(() => {
    if (status) {
      setConsolidationStatus(status);
    }
  }, [status]);

  // ? Update Report
  const handleClickStatusReport = () => {
    dispatch(
      createOrganizationReport({
        uuid: uuid,
        organization_uuid: organization_uuid,
        status: consolidationStatus,
        dd_fund: +organization.organization_classification.dd_fund,
        program_fund: +organization.organization_classification.program_fund,
        utilization_fund: +organization.organization_classification
          .utilization_fund
      })
    )
      .then(res => {
        dispatch(getOrganizationReportById(id));
        toast.success(res.data.message, toastOption);
      })
      .catch(err => {
        toast.error(err.message);
      });
  };

  // ? Generate Memo PPD
  const generateMemo = async value => {
    setLoading(true);
    await generateMemoPPD(uuid)
      .then(res => {
        const url = URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `${value.filename}.pdf`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(err => {
        console.log(`err`, err);
        toast.error("Gagal generate memo ppd");
      })
      .then(() => {
        setLoading(false);
        setOpenModal(prev => ({ ...prev, organizationReport: false }));
      });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading || loading} />
      {/* Generate Memo PPD */}
      <GenerateMemoModal
        show={openModal.generate}
        onHide={() => setOpenModal(prev => ({ ...prev, generate: false }))}
        onClick={generateMemo}
        title="Generate Memo PPD"
        initialValues={{}}
      />
      <Card>
        <CardHeader title={"Detail Laporan"}>
          <CardHeaderToolbar>
            <span className="mx-2">{StatusColumnFormatter(status)}</span>
            {[
              ORG_CONSOLIDATION_STATUS.FINANCE,
              ORG_CONSOLIDATION_STATUS.PAID
            ].includes(status) && (
              <button
                className="btn btn-outline-dark mx-2"
                onClick={() =>
                  setOpenModal(prev => ({ ...prev, generate: true }))
                }
              >
                Generate Memo
              </button>
            )}
            <button
              className="btn btn-secondary"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <>
            <div className="row">
              <div className="col">
                <div className="container mt-5">
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Nama Lembaga</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal">
                      <span>{organization.name}</span>
                    </div>
                  </div>
                  {leftSideDetail.map(item => (
                    <div className="d-flex mb-5">
                      <div className="mx-2 h6 font-weight-bold">
                        <span>{item.label}</span>
                      </div>
                      <span>:</span>
                      <div className="mx-2 h6 font-weight-normal">
                        <span>{organizationReportForEdit[item.key]}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col">
                <div className="container mt-5">
                  {rightSideDetail.map(item => (
                    <div className="d-flex mb-5">
                      <div className="mx-2 h6 font-weight-bold">
                        <span>{item.label}</span>
                      </div>
                      <span>:</span>
                      <div className="mx-2 h6 font-weight-normal ml-auto">
                        <span>
                          {currencyFormatter(
                            organizationReportForEdit[item.key]
                          )}
                        </span>
                      </div>
                    </div>
                  ))}
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Total</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal ml-auto">
                      <span>{currencyFormatter(subTotal)}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Dana DD</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal">
                      <span>{`${organization.organization_classification &&
                        organization.organization_classification.dd_fund *
                          100}%`} dari Total = {currencyFormatter(organization.organization_classification?.dd_fund * subTotal)}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Dana Program Bersama</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal">
                      <span>{`${organization.organization_classification &&
                        organization.organization_classification.program_fund *
                          100}%`} dari Total = {currencyFormatter(organization.organization_classification?.program_fund * subTotal)}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Dana Pendayagunaan</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal">
                      <span>{`${organization.organization_classification &&
                        organization.organization_classification
                          .utilization_fund * 100}%`} dari Total = {currencyFormatter(organization.organization_classification?.utilization_fund * subTotal)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h4>Laporan Attachment</h4>
            <div className="row">
              <div className="col">
                <ListGroup as="ol">
                  {attachmentList.map(item => (
                    <ListGroup.Item
                      as="li"
                      className="d-flex justify-content-between align-items-start"
                    >
                      <div className="ms-2 me-auto">
                        <div className="fw-bold">{item.label}</div>
                      </div>
                      {organizationReportForEdit[item.key] ? (
                        <a
                          onClick={() =>
                            window.open(
                              `${organizationReportForEdit[item.key].storage}/${
                                organizationReportForEdit[item.key].path
                              }`
                            )
                          }
                        >
                          Lihat
                        </a>
                      ) : (
                        <span>File tidak ditemukkan</span>
                      )}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
            </div>
          </>
        </CardBody>
        <CardFooter>
          {status !== ORG_CONSOLIDATION_STATUS.PAID && (
            <div className="d-flex justify-content-end">
              <select
                className="form-control w-25 mx-2"
                placeholder="Pilih Status Konsolidasi"
                name="collectStatus"
                // onBlur={handleBlur}
                onChange={e => {
                  setConsolidationStatus(e.target.value);
                }}
                value={consolidationStatus}
              >
                {Object.keys(ORG_CONSOLIDATION_STATUS).map(key => (
                  <option key={key} value={ORG_CONSOLIDATION_STATUS[key]}>
                    {ORG_CONSOLIDATION_STATUS_DESC[key]}
                  </option>
                ))}
              </select>
              <button
                className="btn btn-success mx-2 float-right"
                onClick={() => handleClickStatusReport()}
                disabled={
                  !consolidationStatus || status === consolidationStatus
                }
              >
                Simpan
              </button>
            </div>
          )}
          {/* {organizationReportForEdit.status ==
            ORGANIZATION_REPORT_STATUS.SUBMIT && (
            <>
              <button
                className="btn btn-danger float-right"
                onClick={() => handleClickStatusReport("REJECT")}
              >
                Reject
              </button>
              <button
                className="btn btn-success float-right"
                onClick={() => handleClickStatusReport("APPROVE")}
              >
                Approve
              </button>
            </>
          )} */}
        </CardFooter>
      </Card>
    </>
  );
}
